"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6135],{

/***/ 79074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ft": function() { return /* binding */ useAllPoolDataSWR; },
  "jF": function() { return /* binding */ useAllTokenDataSWR; },
  "qg": function() { return /* binding */ hooks_useGetChainName; },
  "hb": function() { return /* binding */ useMultiChainPath; },
  "zo": function() { return /* binding */ usePoolChartDataSWR; },
  "gw": function() { return /* binding */ usePoolDatasSWR; },
  "A$": function() { return /* binding */ usePoolTransactionsSWR; },
  "P6": function() { return /* binding */ usePoolsForTokenSWR; },
  "Xx": function() { return /* binding */ useProtocolChartDataSWR; },
  "hw": function() { return /* binding */ useProtocolDataSWR; },
  "H8": function() { return /* binding */ useProtocolTransactionsSWR; },
  "PP": function() { return /* binding */ useStableSwapAPR; },
  "U1": function() { return /* binding */ useStableSwapPath; },
  "BS": function() { return /* binding */ useStableSwapTopPoolsAPR; },
  "Jj": function() { return /* binding */ useTokenChartDataSWR; },
  "b6": function() { return /* binding */ useTokenDataSWR; },
  "ZF": function() { return /* binding */ useTokenDatasSWR; },
  "QB": function() { return /* binding */ useTokenPriceDataSWR; },
  "nT": function() { return /* binding */ useTokenTransactionsSWR; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js + 1 modules
var getUnixTime = __webpack_require__(28401);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfHour/index.js
var startOfHour = __webpack_require__(12383);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/sub/index.js + 1 modules
var sub = __webpack_require__(20005);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(6647);
// EXTERNAL MODULE: ../../packages/swap-sdk/dist/index.mjs + 1 modules
var swap_sdk_dist = __webpack_require__(72027);
// EXTERNAL MODULE: ../../node_modules/lodash/fromPairs.js
var fromPairs = __webpack_require__(10017);
var fromPairs_default = /*#__PURE__*/__webpack_require__.n(fromPairs);
// EXTERNAL MODULE: ../../node_modules/lodash/chunk.js
var lodash_chunk = __webpack_require__(93586);
// EXTERNAL MODULE: ../../node_modules/lodash/uniq.js
var lodash_uniq = __webpack_require__(75652);
// EXTERNAL MODULE: ../../node_modules/lodash/mapValues.js
var lodash_mapValues = __webpack_require__(34519);
// EXTERNAL MODULE: ./src/config/constants/info.ts
var info = __webpack_require__(26390);
// EXTERNAL MODULE: ./src/config/abi/IPancakePair.json
var IPancakePair = __webpack_require__(93725);
// EXTERNAL MODULE: ./src/config/abi/erc20.json
var erc20 = __webpack_require__(93324);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(60242);
// EXTERNAL MODULE: ./src/state/info/types.ts
var types = __webpack_require__(43386);
// EXTERNAL MODULE: ./src/state/info/constant.ts
var constant = __webpack_require__(64867);
;// CONCATENATED MODULE: ./src/state/info/queries/helpers.ts

















var mapMints = function(mint) {
    return {
        type: types/* TransactionType.MINT */.i.MINT,
        hash: mint.id.split("-")[0],
        timestamp: mint.timestamp,
        sender: mint.to,
        token0Symbol: mint.pair.token0.symbol,
        token1Symbol: mint.pair.token1.symbol,
        token0Address: mint.pair.token0.id,
        token1Address: mint.pair.token1.id,
        amountUSD: parseFloat(mint.amountUSD),
        amountToken0: parseFloat(mint.amount0),
        amountToken1: parseFloat(mint.amount1)
    };
};
var mapBurns = function(burn) {
    return {
        type: types/* TransactionType.BURN */.i.BURN,
        hash: burn.id.split("-")[0],
        timestamp: burn.timestamp,
        sender: burn.sender,
        token0Symbol: burn.pair.token0.symbol,
        token1Symbol: burn.pair.token1.symbol,
        token0Address: burn.pair.token0.id,
        token1Address: burn.pair.token1.id,
        amountUSD: parseFloat(burn.amountUSD),
        amountToken0: parseFloat(burn.amount0),
        amountToken1: parseFloat(burn.amount1)
    };
};
var mapSwaps = function(swap) {
    return {
        type: types/* TransactionType.SWAP */.i.SWAP,
        hash: swap.id.split("-")[0],
        timestamp: swap.timestamp,
        sender: swap.from,
        token0Symbol: swap.pair.token0.symbol,
        token1Symbol: swap.pair.token1.symbol,
        token0Address: swap.pair.token0.id,
        token1Address: swap.pair.token1.id,
        amountUSD: parseFloat(swap.amountUSD),
        amountToken0: parseFloat(swap.amount0In) - parseFloat(swap.amount0Out),
        amountToken1: parseFloat(swap.amount1In) - parseFloat(swap.amount1Out)
    };
};
var mapDayData = function(tokenDayData) {
    return {
        date: tokenDayData.date,
        volumeUSD: parseFloat(tokenDayData.dailyVolumeUSD),
        liquidityUSD: parseFloat(tokenDayData.totalLiquidityUSD)
    };
};
var mapPairDayData = function(pairDayData) {
    return {
        date: pairDayData.date,
        volumeUSD: parseFloat(pairDayData.dailyVolumeUSD),
        liquidityUSD: parseFloat(pairDayData.reserveUSD)
    };
};
// Common helper function to retrieve chart data
// Used for both Pool and Token charts
var helpers_fetchChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, getEntityDayDatas) {
        var chartEntries, error, skip, allFound, _ref, data, fetchError, formattedDayDatas, availableDays, firstAvailableDayData, _firstAvailableDayData_date, timestamp, _firstAvailableDayData_liquidityUSD, latestLiquidityUSD, endTimestamp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chartEntries = [];
                    error = false;
                    skip = 0;
                    allFound = false;
                    _state.label = 1;
                case 1:
                    if (!(!allFound && !error)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        getEntityDayDatas(chainName, skip)
                    ];
                case 2:
                    _ref = _state.sent(), data = _ref.data, fetchError = _ref.error;
                    skip += 1000;
                    allFound = (data === null || data === void 0 ? void 0 : data.length) < 1000 || skip > 2000;
                    error = fetchError;
                    if (data) {
                        chartEntries = chartEntries.concat(data);
                    }
                    return [
                        3,
                        1
                    ];
                case 3:
                    if (error || chartEntries.length === 0) {
                        return [
                            2,
                            {
                                error: true
                            }
                        ];
                    }
                    formattedDayDatas = fromPairs_default()(chartEntries.map(function(dayData) {
                        // At this stage we track unix day ordinal for each data point to check for empty days later
                        var dayOrdinal = parseInt((dayData.date / info/* ONE_DAY_UNIX */.Bq).toFixed(0));
                        return [
                            dayOrdinal,
                            dayData
                        ];
                    }));
                    console.warn(formattedDayDatas);
                    availableDays = Object.keys(formattedDayDatas).map(function(dayOrdinal) {
                        return parseInt(dayOrdinal, 10);
                    });
                    firstAvailableDayData = formattedDayDatas[availableDays[0]];
                    timestamp = (_firstAvailableDayData_date = firstAvailableDayData === null || firstAvailableDayData === void 0 ? void 0 : firstAvailableDayData.date) !== null && _firstAvailableDayData_date !== void 0 ? _firstAvailableDayData_date : constant/* multiChainStartTime */.YM[chainName];
                    latestLiquidityUSD = (_firstAvailableDayData_liquidityUSD = firstAvailableDayData === null || firstAvailableDayData === void 0 ? void 0 : firstAvailableDayData.liquidityUSD) !== null && _firstAvailableDayData_liquidityUSD !== void 0 ? _firstAvailableDayData_liquidityUSD : 0;
                    endTimestamp = (0,getUnixTime/* default */.Z)(new Date());
                    while(timestamp < endTimestamp - info/* ONE_DAY_UNIX */.Bq){
                        timestamp += info/* ONE_DAY_UNIX */.Bq;
                        var dayOrdinal = parseInt((timestamp / info/* ONE_DAY_UNIX */.Bq).toFixed(0), 10);
                        if (!Object.keys(formattedDayDatas).includes(dayOrdinal.toString())) {
                            formattedDayDatas[dayOrdinal] = {
                                date: timestamp,
                                volumeUSD: 0,
                                liquidityUSD: latestLiquidityUSD
                            };
                        } else {
                            latestLiquidityUSD = formattedDayDatas[dayOrdinal].liquidityUSD;
                        }
                    }
                    return [
                        2,
                        {
                            data: Object.values(formattedDayDatas),
                            error: false
                        }
                    ];
            }
        });
    });
    return function fetchChartData(chainName, getEntityDayDatas) {
        return _ref.apply(this, arguments);
    };
}();
var fetchChartDataWithAddress = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, getEntityDayDatas, address) {
        var chartEntries, error, skip, allFound, _ref, data, fetchError, formattedDayDatas, availableDays, firstAvailableDayData, _firstAvailableDayData_date, timestamp, _firstAvailableDayData_liquidityUSD, latestLiquidityUSD, endTimestamp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chartEntries = [];
                    error = false;
                    skip = 0;
                    allFound = false;
                    _state.label = 1;
                case 1:
                    if (!(!allFound && !error)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        getEntityDayDatas(chainName, skip, address)
                    ];
                case 2:
                    _ref = _state.sent(), data = _ref.data, fetchError = _ref.error;
                    skip += 1000;
                    allFound = (data === null || data === void 0 ? void 0 : data.length) < 1000 || skip > 2000;
                    error = fetchError;
                    if (data) {
                        chartEntries = chartEntries.concat(data);
                    }
                    return [
                        3,
                        1
                    ];
                case 3:
                    if (error || chartEntries.length === 0) {
                        return [
                            2,
                            {
                                error: true
                            }
                        ];
                    }
                    formattedDayDatas = fromPairs_default()(chartEntries.map(function(dayData) {
                        // At this stage we track unix day ordinal for each data point to check for empty days later
                        var dayOrdinal = parseInt((dayData.date / info/* ONE_DAY_UNIX */.Bq).toFixed(0));
                        return [
                            dayOrdinal,
                            dayData
                        ];
                    }));
                    console.warn(formattedDayDatas);
                    availableDays = Object.keys(formattedDayDatas).map(function(dayOrdinal) {
                        return parseInt(dayOrdinal, 10);
                    });
                    firstAvailableDayData = formattedDayDatas[availableDays[0]];
                    timestamp = (_firstAvailableDayData_date = firstAvailableDayData === null || firstAvailableDayData === void 0 ? void 0 : firstAvailableDayData.date) !== null && _firstAvailableDayData_date !== void 0 ? _firstAvailableDayData_date : constant/* multiChainStartTime */.YM[chainName];
                    latestLiquidityUSD = (_firstAvailableDayData_liquidityUSD = firstAvailableDayData === null || firstAvailableDayData === void 0 ? void 0 : firstAvailableDayData.liquidityUSD) !== null && _firstAvailableDayData_liquidityUSD !== void 0 ? _firstAvailableDayData_liquidityUSD : 0;
                    endTimestamp = (0,getUnixTime/* default */.Z)(new Date());
                    while(timestamp < endTimestamp - info/* ONE_DAY_UNIX */.Bq){
                        timestamp += info/* ONE_DAY_UNIX */.Bq;
                        var dayOrdinal = parseInt((timestamp / info/* ONE_DAY_UNIX */.Bq).toFixed(0), 10);
                        if (!Object.keys(formattedDayDatas).includes(dayOrdinal.toString())) {
                            formattedDayDatas[dayOrdinal] = {
                                date: timestamp,
                                volumeUSD: 0,
                                liquidityUSD: latestLiquidityUSD
                            };
                        } else {
                            latestLiquidityUSD = formattedDayDatas[dayOrdinal].liquidityUSD;
                        }
                    }
                    return [
                        2,
                        {
                            data: Object.values(formattedDayDatas),
                            error: false
                        }
                    ];
            }
        });
    });
    return function fetchChartDataWithAddress(chainName, getEntityDayDatas, address) {
        return _ref.apply(this, arguments);
    };
}();
function getPairTokenMap(poolAddresses, chainName) {
    return _getPairTokenMap.apply(this, arguments);
}
function _getPairTokenMap() {
    _getPairTokenMap = _async_to_generator(function(poolAddresses, chainName) {
        var rawPairTokenResults, calls, error, pairTokenResults, pairTokenMap, rawTokenResults, uniquePairTokenResults, tokenCalls, error1, tokenResults, tokenMap;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    calls = poolAddresses.map(function(poolAddress) {
                        return [
                            {
                                address: poolAddress,
                                name: "token0"
                            },
                            {
                                address: poolAddress,
                                name: "token1"
                            }
                        ];
                    }).flat();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        multicallv2({
                            abi: IPancakePairABI,
                            calls: calls,
                            options: {
                                requireSuccess: false
                            },
                            chainId: chainName === "ETH" ? ChainId.ETHEREUM : ChainId.BSC
                        })
                    ];
                case 2:
                    rawPairTokenResults = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.info("Error fetching tokenIds from pair");
                    return [
                        3,
                        4
                    ];
                case 4:
                    pairTokenResults = rawPairTokenResults ? rawPairTokenResults.map(function(rawPairTokenResult) {
                        return rawPairTokenResult[0].toLowerCase();
                    }) : [];
                    pairTokenMap = chunk(pairTokenResults, 2).reduce(function(acc, tokenResult, index) {
                        return _object_spread_props(_object_spread({}, acc), _define_property({}, poolAddresses[index].toLowerCase(), {
                            token0: tokenResult[0],
                            token1: tokenResult[1]
                        }));
                    }, {});
                    uniquePairTokenResults = uniq(pairTokenResults);
                    tokenCalls = uniquePairTokenResults.map(function(pairToken) {
                        return [
                            {
                                address: pairToken,
                                name: "name"
                            },
                            {
                                address: pairToken,
                                name: "symbol"
                            }
                        ];
                    }).flat();
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        multicallv2({
                            abi: bep20Abi,
                            calls: tokenCalls,
                            options: {
                                requireSuccess: false
                            },
                            chainId: chainName === "ETH" ? ChainId.ETHEREUM : ChainId.BSC
                        })
                    ];
                case 6:
                    rawTokenResults = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 7:
                    error1 = _state.sent();
                    console.info("Error fetching tokenIds from pair");
                    return [
                        3,
                        8
                    ];
                case 8:
                    tokenResults = rawTokenResults ? rawTokenResults.map(function(rawTokenResult) {
                        return rawTokenResult[0];
                    }) : [];
                    tokenMap = chunk(tokenResults, 2).reduce(function(acc, tokenResult, index) {
                        return _object_spread_props(_object_spread({}, acc), _define_property({}, uniquePairTokenResults[index].toLowerCase(), {
                            name: tokenResult[0],
                            symbol: tokenResult[1]
                        }));
                    }, {});
                    return [
                        2,
                        mapValues(pairTokenMap, function(pairTokenValue) {
                            return {
                                token0: _object_spread({
                                    id: pairTokenValue.token0
                                }, tokenMap[pairTokenValue.token0]),
                                token1: _object_spread({
                                    id: pairTokenValue.token1
                                }, tokenMap[pairTokenValue.token1])
                            };
                        })
                    ];
            }
        });
    });
    return _getPairTokenMap.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/state/info/queries/pools/chartData.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query pairDayDatas($startTime: Int!, $skip: Int!, $address: Bytes!) {\n        pairDayDatas(\n          first: 1000\n          skip: $skip\n          where: { pairAddress: $address, date_gt: $startTime }\n          orderBy: date\n          orderDirection: asc\n        ) {\n          date\n          dailyVolumeUSD\n          reserveUSD\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var getPoolChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, skip, address) {
        var query, pairDayDatas, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    query = (0,dist.gql)(_templateObject());
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query, {
                            startTime: constant/* multiChainStartTime */.YM[chainName],
                            skip: skip,
                            address: address
                        })
                    ];
                case 1:
                    pairDayDatas = _state.sent().pairDayDatas;
                    data = pairDayDatas.map(mapPairDayData);
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch pool chart data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPoolChartData(chainName, skip, address) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPoolChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                fetchChartDataWithAddress(chainName, getPoolChartData, address)
            ];
        });
    });
    return function fetchPoolChartData(chainName, address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var chartData = (fetchPoolChartData);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(6391);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ../../node_modules/lodash/toLower.js
var toLower = __webpack_require__(53982);
var toLower_default = /*#__PURE__*/__webpack_require__.n(toLower);
// EXTERNAL MODULE: ./src/utils/getBlocksFromTimestamps.ts
var utils_getBlocksFromTimestamps = __webpack_require__(20337);
// EXTERNAL MODULE: ./src/utils/getChangeForPeriod.ts
var utils_getChangeForPeriod = __webpack_require__(8244);
// EXTERNAL MODULE: ./src/utils/getDeltaTimestamps.ts
var utils_getDeltaTimestamps = __webpack_require__(14966);
;// CONCATENATED MODULE: ./src/utils/getLpFeesAndApr.ts

var getLpFeesAndApr_getLpFeesAndApr = function(volumeUSD, volumeUSDWeek, liquidityUSD) {
    var totalFees24h = volumeUSD * info/* TOTAL_FEE */.om;
    var totalFees7d = volumeUSDWeek * info/* TOTAL_FEE */.om;
    var lpFees24h = volumeUSD * info/* LP_HOLDERS_FEE */.BY;
    var lpFees7d = volumeUSDWeek * info/* LP_HOLDERS_FEE */.BY;
    var lpApr7d = liquidityUSD > 0 ? volumeUSDWeek * info/* LP_HOLDERS_FEE */.BY * info/* WEEKS_IN_YEAR */.MV * 100 / liquidityUSD : 0;
    return {
        totalFees24h: totalFees24h,
        totalFees7d: totalFees7d,
        lpFees24h: lpFees24h,
        lpFees7d: lpFees7d,
        lpApr7d: lpApr7d !== Infinity ? lpApr7d : 0
    };
};

// EXTERNAL MODULE: ../../node_modules/swr/immutable/dist/index.mjs
var immutable_dist = __webpack_require__(2303);
;// CONCATENATED MODULE: ./src/views/Info/hooks/useBlocksFromTimestamps.ts







/**
 * for a given array of timestamps, returns block entities
 * @param timestamps
 * @param sortDirection
 * @param skipCount
 */ var useBlocksFromTimestamps_useBlocksFromTimestamps = function(timestamps) {
    var sortDirection = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "desc", skipCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
    var _useState = _sliced_to_array(useState(), 2), blocks = _useState[0], setBlocks = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), error = _useState1[0], setError = _useState1[1];
    var timestampsString = JSON.stringify(timestamps);
    var blocksString = blocks ? JSON.stringify(blocks) : undefined;
    var chainName = useGetChainName();
    useEffect(function() {
        var fetchData = function() {
            var _ref = _async_to_generator(function() {
                var timestampsArray, result;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            timestampsArray = JSON.parse(timestampsString);
                            return [
                                4,
                                getBlocksFromTimestamps(timestampsArray, sortDirection, skipCount, chainName)
                            ];
                        case 1:
                            result = _state.sent();
                            if (result.length === 0) {
                                setError(true);
                            } else {
                                setBlocks(result);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        var blocksArray = blocksString ? JSON.parse(blocksString) : undefined;
        if (!blocksArray && !error && chainName) {
            fetchData();
        }
    }, [
        blocksString,
        error,
        skipCount,
        sortDirection,
        timestampsString,
        chainName
    ]);
    return {
        blocks: blocks,
        error: error
    };
};
var useBlockFromTimeStampSWR = function(timestamps) {
    var sortDirection = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "desc", skipCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
    var chainName = hooks_useGetChainName();
    var timestampsString = JSON.stringify(timestamps);
    var timestampsArray = JSON.parse(timestampsString);
    var data = (0,immutable_dist/* default */.Z)([
        "info/blocks/".concat(timestampsString),
        chainName
    ], function() {
        return (0,utils_getBlocksFromTimestamps/* getBlocksFromTimestamps */.z)(timestampsArray, sortDirection, skipCount, chainName);
    }).data;
    return {
        blocks: data
    };
};

// EXTERNAL MODULE: ./src/views/Info/utils/infoDataHelpers.ts
var infoDataHelpers = __webpack_require__(27867);
// EXTERNAL MODULE: ./src/utils/graphql.ts
var graphql = __webpack_require__(74958);
;// CONCATENATED MODULE: ./src/state/info/queries/pools/topPools.ts




function topPools_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query topPools($blacklist: [String!]) {\n        pairDayDatas(\n          first: ",
        "\n          ",
        "\n          orderBy: dailyVolumeUSD\n          orderDirection: desc\n        ) {\n          id\n        }\n      }\n    "
    ]);
    topPools_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Initial pools to display on the home page
 */ var fetchTopPools = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, timestamp24hAgo) {
        var isStableSwap, firstCount, whereCondition, query, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isStableSwap = (0,constant/* checkIsStableSwap */.J5)();
                    firstCount = isStableSwap ? 100 : 30;
                    whereCondition = chainName === "BSC" ? "where: { dailyTxns_gt: 300, token0_not_in: $blacklist, token1_not_in: $blacklist, date_gt: ".concat(timestamp24hAgo, " }") : "where: { date_gt: ".concat(timestamp24hAgo, ", token0_not_in: $blacklist, token1_not_in: $blacklist, dailyVolumeUSD_gt: 2000 }");
                    if (isStableSwap) whereCondition = "";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    query = (0,dist.gql)(topPools_templateObject(), firstCount, whereCondition);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query, {
                            blacklist: constant/* multiChainTokenBlackList */.z2[chainName]
                        })
                    ];
                case 2:
                    data = _state.sent();
                    // pairDayDatas id has compound id "0xPOOLADDRESS-NUMBERS", extracting pool address with .split('-')
                    return [
                        2,
                        data.pairDayDatas.map(function(p) {
                            return p.id.split("-")[0];
                        })
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Failed to fetch top pools", error);
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTopPools(chainName, timestamp24hAgo) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch top addresses by volume
 */ var useTopPoolAddresses = function() {
    var _useState = _sliced_to_array(useState([]), 2), topPoolAddresses = _useState[0], setTopPoolAddresses = _useState[1];
    var _getDeltaTimestamps = _sliced_to_array(getDeltaTimestamps(), 1), timestamp24hAgo = _getDeltaTimestamps[0];
    var chainName = useGetChainName();
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(function() {
                var addresses;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchTopPools(chainName, timestamp24hAgo)
                            ];
                        case 1:
                            addresses = _state.sent();
                            setTopPoolAddresses(addresses);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (topPoolAddresses.length === 0) {
            fetch();
        }
    }, [
        topPoolAddresses,
        timestamp24hAgo,
        chainName
    ]);
    return topPoolAddresses;
};
var fetchTopPoolAddresses = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName) {
        var _getDeltaTimestamps, timestamp24hAgo, addresses;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _getDeltaTimestamps = (0,src_sliced_to_array/* default */.Z)((0,utils_getDeltaTimestamps/* getDeltaTimestamps */.z)(), 1), timestamp24hAgo = _getDeltaTimestamps[0];
                    return [
                        4,
                        fetchTopPools(chainName, timestamp24hAgo)
                    ];
                case 1:
                    addresses = _state.sent();
                    return [
                        2,
                        addresses
                    ];
            }
        });
    });
    return function fetchTopPoolAddresses(chainName) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var topPools = ((/* unused pure expression or super */ null && (useTopPoolAddresses)));

;// CONCATENATED MODULE: ./src/state/info/queries/pools/poolData.ts
/* eslint-disable no-param-reassign */ 





function poolData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query pools {\n        now: ",
        "\n        oneDayAgo: ",
        "\n        twoDaysAgo: ",
        "\n        oneWeekAgo: ",
        "\n        twoWeeksAgo: ",
        "\n      }\n    "
    ]);
    poolData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        query virtualPriceStableSwap($stableSwapAddress: String, $blockDayAgo: Int!) {\n          virtualPriceAtLatestBlock: pair(id: $stableSwapAddress) {\n            virtualPrice\n          }\n          virtualPriceOneDayAgo: pair(id: $stableSwapAddress, block: { number: $blockDayAgo }) {\n            virtualPrice\n          }\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














/**
 * Data for displaying pool tables (on multiple pages, used throughout the site)
 * Note: Don't try to refactor it to use variables, server throws error if blocks passed as undefined variable
 * only works if its hard-coded into query string
 */ var POOL_AT_BLOCK = function(chainName, block, pools) {
    var blockString = block ? "block: {number: ".concat(block, "}") : "";
    var addressesString = '["'.concat(pools.join('","'), '"]');
    return "pairs(\n    where: { id_in: ".concat(addressesString, " }\n    ").concat(blockString, "\n    orderBy: trackedReserve").concat(constant/* multiChainQueryMainToken */.WR[chainName], "\n    orderDirection: desc\n  ) {\n    id\n    reserve0\n    reserve1\n    reserveUSD\n    volumeUSD\n    token0Price\n    token1Price\n    token0 {\n      id\n      symbol\n      name\n    }\n    token1 {\n      id\n      symbol\n      name\n    }\n  }");
};
var fetchPoolData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(block24h, block48h, block7d, block14d, poolAddresses) {
        var chainName, query, data, error;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chainName = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : "BSC";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    query = (0,dist.gql)(poolData_templateObject(), POOL_AT_BLOCK(chainName, null, poolAddresses), POOL_AT_BLOCK(chainName, block24h, poolAddresses), POOL_AT_BLOCK(chainName, block48h, poolAddresses), POOL_AT_BLOCK(chainName, block7d, poolAddresses), POOL_AT_BLOCK(chainName, block14d, poolAddresses));
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query)
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Failed to fetch pool data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPoolData(block24h, block48h, block7d, block14d, poolAddresses) {
        return _ref.apply(this, arguments);
    };
}();
// Transforms pools into "0xADDRESS: { ...PoolFields }" format and cast strings to numbers
var parsePoolData = function(pairs) {
    if (!pairs) {
        return {};
    }
    return pairs.reduce(function(accum, poolData) {
        var volumeUSD = poolData.volumeUSD, reserveUSD = poolData.reserveUSD, reserve0 = poolData.reserve0, reserve1 = poolData.reserve1, token0Price = poolData.token0Price, token1Price = poolData.token1Price;
        accum[poolData.id.toLowerCase()] = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, poolData), {
            volumeUSD: parseFloat(volumeUSD),
            reserveUSD: parseFloat(reserveUSD),
            reserve0: parseFloat(reserve0),
            reserve1: parseFloat(reserve1),
            token0Price: parseFloat(token0Price),
            token1Price: parseFloat(token1Price)
        });
        return accum;
    }, {});
};
/**
 * Fetch top pools by liquidity
 */ var usePoolDatas = function(poolAddresses) {
    var _useState = _sliced_to_array(useState({
        error: false
    }), 2), fetchState = _useState[0], setFetchState = _useState[1];
    var _getDeltaTimestamps = _sliced_to_array(getDeltaTimestamps(), 4), t24h = _getDeltaTimestamps[0], t48h = _getDeltaTimestamps[1], t7d = _getDeltaTimestamps[2], t14d = _getDeltaTimestamps[3];
    var _useBlocksFromTimestamps = useBlocksFromTimestamps([
        t24h,
        t48h,
        t7d,
        t14d
    ]), blocks = _useBlocksFromTimestamps.blocks, blockError = _useBlocksFromTimestamps.error;
    var _ref = _sliced_to_array(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = _ref[0], block48h = _ref[1], block7d = _ref[2], block14d = _ref[3];
    var chainName = useGetChainName();
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(function() {
                var _ref, error, data, formattedPoolData, formattedPoolData24h, formattedPoolData48h, formattedPoolData7d, formattedPoolData14d, formatted;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchPoolData(block24h.number, block48h.number, block7d.number, block14d.number, poolAddresses, chainName)
                            ];
                        case 1:
                            _ref = _state.sent(), error = _ref.error, data = _ref.data;
                            if (error) {
                                setFetchState({
                                    error: true
                                });
                            } else {
                                formattedPoolData = parsePoolData(data === null || data === void 0 ? void 0 : data.now);
                                formattedPoolData24h = parsePoolData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                                formattedPoolData48h = parsePoolData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                                formattedPoolData7d = parsePoolData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                                formattedPoolData14d = parsePoolData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                                formatted = poolAddresses.reduce(function(accum, address) {
                                    // Undefined data is possible if pool is brand new and didn't exist one day ago or week ago.
                                    var current = formattedPoolData[address];
                                    var oneDay = formattedPoolData24h[address];
                                    var twoDays = formattedPoolData48h[address];
                                    var week = formattedPoolData7d[address];
                                    var twoWeeks = formattedPoolData14d[address];
                                    var _getChangeForPeriod = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.volumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.volumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.volumeUSD), 2), volumeUSD = _getChangeForPeriod[0], volumeUSDChange = _getChangeForPeriod[1];
                                    var _getChangeForPeriod1 = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.volumeUSD, week === null || week === void 0 ? void 0 : week.volumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.volumeUSD), 2), volumeUSDWeek = _getChangeForPeriod1[0], volumeUSDChangeWeek = _getChangeForPeriod1[1];
                                    var liquidityUSD = current ? current.reserveUSD : 0;
                                    var liquidityUSDChange = getPercentChange(current === null || current === void 0 ? void 0 : current.reserveUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.reserveUSD);
                                    var liquidityToken0 = current ? current.reserve0 : 0;
                                    var liquidityToken1 = current ? current.reserve1 : 0;
                                    var _getLpFeesAndApr = getLpFeesAndApr(volumeUSD, volumeUSDWeek, liquidityUSD), totalFees24h = _getLpFeesAndApr.totalFees24h, totalFees7d = _getLpFeesAndApr.totalFees7d, lpFees24h = _getLpFeesAndApr.lpFees24h, lpFees7d = _getLpFeesAndApr.lpFees7d, lpApr7d = _getLpFeesAndApr.lpApr7d;
                                    if (current) {
                                        accum[address] = {
                                            address: address,
                                            token0: {
                                                address: current.token0.id,
                                                name: current.token0.name,
                                                symbol: current.token0.symbol
                                            },
                                            token1: {
                                                address: current.token1.id,
                                                name: current.token1.name,
                                                symbol: current.token1.symbol
                                            },
                                            token0Price: current.token0Price,
                                            token1Price: current.token1Price,
                                            volumeUSD: volumeUSD,
                                            volumeUSDChange: volumeUSDChange,
                                            volumeUSDWeek: volumeUSDWeek,
                                            volumeUSDChangeWeek: volumeUSDChangeWeek,
                                            totalFees24h: totalFees24h,
                                            totalFees7d: totalFees7d,
                                            lpFees24h: lpFees24h,
                                            lpFees7d: lpFees7d,
                                            lpApr7d: lpApr7d,
                                            liquidityUSD: liquidityUSD,
                                            liquidityUSDChange: liquidityUSDChange,
                                            liquidityToken0: liquidityToken0,
                                            liquidityToken1: liquidityToken1
                                        };
                                    }
                                    return accum;
                                }, {});
                                setFetchState({
                                    data: formatted,
                                    error: false
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        var allBlocksAvailable = (block24h === null || block24h === void 0 ? void 0 : block24h.number) && (block48h === null || block48h === void 0 ? void 0 : block48h.number) && (block7d === null || block7d === void 0 ? void 0 : block7d.number) && (block14d === null || block14d === void 0 ? void 0 : block14d.number);
        if (poolAddresses.length > 0 && allBlocksAvailable && !blockError) {
            fetch();
        }
    }, [
        poolAddresses,
        block24h,
        block48h,
        block7d,
        block14d,
        blockError,
        chainName
    ]);
    return fetchState;
};
var fetchAllPoolDataWithAddress = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(blocks, chainName, poolAddresses) {
        var _ref, block24h, block48h, block7d, block14d, data, formattedPoolData, formattedPoolData24h, formattedPoolData48h, formattedPoolData7d, formattedPoolData14d, formatted;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = (0,src_sliced_to_array/* default */.Z)(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = _ref[0], block48h = _ref[1], block7d = _ref[2], block14d = _ref[3];
                    return [
                        4,
                        fetchPoolData(block24h.number, block48h.number, block7d.number, block14d.number, poolAddresses, chainName)
                    ];
                case 1:
                    data = _state.sent().data;
                    formattedPoolData = parsePoolData(data === null || data === void 0 ? void 0 : data.now);
                    formattedPoolData24h = parsePoolData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                    formattedPoolData48h = parsePoolData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                    formattedPoolData7d = parsePoolData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                    formattedPoolData14d = parsePoolData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                    formatted = poolAddresses.reduce(function(accum, address) {
                        // Undefined data is possible if pool is brand new and didn't exist one day ago or week ago.
                        var current = formattedPoolData[address];
                        var oneDay = formattedPoolData24h[address];
                        var twoDays = formattedPoolData48h[address];
                        var week = formattedPoolData7d[address];
                        var twoWeeks = formattedPoolData14d[address];
                        var _getChangeForPeriod = (0,src_sliced_to_array/* default */.Z)((0,utils_getChangeForPeriod/* getChangeForPeriod */.T)(current === null || current === void 0 ? void 0 : current.volumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.volumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.volumeUSD), 2), volumeUSD = _getChangeForPeriod[0], volumeUSDChange = _getChangeForPeriod[1];
                        var _getChangeForPeriod1 = (0,src_sliced_to_array/* default */.Z)((0,utils_getChangeForPeriod/* getChangeForPeriod */.T)(current === null || current === void 0 ? void 0 : current.volumeUSD, week === null || week === void 0 ? void 0 : week.volumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.volumeUSD), 2), volumeUSDWeek = _getChangeForPeriod1[0], volumeUSDChangeWeek = _getChangeForPeriod1[1];
                        var liquidityUSD = current ? current.reserveUSD : 0;
                        var liquidityUSDChange = (0,infoDataHelpers/* getPercentChange */.Y)(current === null || current === void 0 ? void 0 : current.reserveUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.reserveUSD);
                        var liquidityToken0 = current ? current.reserve0 : 0;
                        var liquidityToken1 = current ? current.reserve1 : 0;
                        var _getLpFeesAndApr = getLpFeesAndApr_getLpFeesAndApr(volumeUSD, volumeUSDWeek, liquidityUSD), totalFees24h = _getLpFeesAndApr.totalFees24h, totalFees7d = _getLpFeesAndApr.totalFees7d, lpFees24h = _getLpFeesAndApr.lpFees24h, lpFees7d = _getLpFeesAndApr.lpFees7d, lpApr7d = _getLpFeesAndApr.lpApr7d;
                        if (current) {
                            accum[address] = {
                                data: {
                                    address: address,
                                    token0: {
                                        address: current.token0.id,
                                        name: current.token0.name,
                                        symbol: current.token0.symbol
                                    },
                                    token1: {
                                        address: current.token1.id,
                                        name: current.token1.name,
                                        symbol: current.token1.symbol
                                    },
                                    token0Price: current.token0Price,
                                    token1Price: current.token1Price,
                                    volumeUSD: volumeUSD,
                                    volumeUSDChange: volumeUSDChange,
                                    volumeUSDWeek: volumeUSDWeek,
                                    volumeUSDChangeWeek: volumeUSDChangeWeek,
                                    totalFees24h: totalFees24h,
                                    totalFees7d: totalFees7d,
                                    lpFees24h: lpFees24h,
                                    lpFees7d: lpFees7d,
                                    lpApr7d: lpApr7d,
                                    liquidityUSD: liquidityUSD,
                                    liquidityUSDChange: liquidityUSDChange,
                                    liquidityToken0: liquidityToken0,
                                    liquidityToken1: liquidityToken1
                                }
                            };
                        }
                        return accum;
                    }, {});
                    return [
                        2,
                        formatted
                    ];
            }
        });
    });
    return function fetchAllPoolDataWithAddress(blocks, chainName, poolAddresses) {
        return _ref.apply(this, arguments);
    };
}();
var fetchAllPoolData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(blocks, chainName) {
        var poolAddresses;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchTopPoolAddresses(chainName)
                    ];
                case 1:
                    poolAddresses = _state.sent();
                    return [
                        2,
                        fetchAllPoolDataWithAddress(blocks, chainName, poolAddresses)
                    ];
            }
        });
    });
    return function fetchAllPoolData(blocks, chainName) {
        return _ref.apply(this, arguments);
    };
}();
var getAprsForStableFarm = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(stableSwapAddress) {
        var _getDeltaTimestamps, t7d, _ref, blockDay7Ago, _ref1, virtualPriceAtLatestBlock, virtualPrice7DayAgo, virtualPrice, preVirtualPrice, current, prev, result, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    _getDeltaTimestamps = (0,src_sliced_to_array/* default */.Z)((0,utils_getDeltaTimestamps/* getDeltaTimestamps */.z)(), 3), t7d = _getDeltaTimestamps[2];
                    return [
                        4,
                        (0,utils_getBlocksFromTimestamps/* getBlocksFromTimestamps */.z)([
                            t7d
                        ])
                    ];
                case 1:
                    _ref = src_sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), blockDay7Ago = _ref[0];
                    return [
                        4,
                        graphql/* stableSwapClient.request */.Wt.request((0,dist.gql)(_templateObject1()), {
                            stableSwapAddress: toLower_default()(stableSwapAddress),
                            blockDayAgo: blockDay7Ago.number
                        })
                    ];
                case 2:
                    _ref1 = _state.sent(), virtualPriceAtLatestBlock = _ref1.virtualPriceAtLatestBlock, virtualPrice7DayAgo = _ref1.virtualPriceOneDayAgo;
                    virtualPrice = virtualPriceAtLatestBlock === null || virtualPriceAtLatestBlock === void 0 ? void 0 : virtualPriceAtLatestBlock.virtualPrice;
                    preVirtualPrice = virtualPrice7DayAgo === null || virtualPrice7DayAgo === void 0 ? void 0 : virtualPrice7DayAgo.virtualPrice;
                    current = new (bignumber_default())(virtualPrice);
                    prev = new (bignumber_default())(preVirtualPrice);
                    result = current.minus(prev).div(current).plus(1).pow(52).minus(1).times(100);
                    if (result.isFinite() && result.isGreaterThan(0)) {
                        return [
                            2,
                            result
                        ];
                    }
                    return [
                        2,
                        new (bignumber_default())(0)
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error, "[LP APR Update] getAprsForStableFarm error");
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        new (bignumber_default())("0")
                    ];
            }
        });
    });
    return function getAprsForStableFarm(stableSwapAddress) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var poolData = ((/* unused pure expression or super */ null && (usePoolDatas)));

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./src/state/info/queries/pools/transactions.ts




function transactions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query poolTransactions($address: ID!) {\n    mints(first: 35, orderBy: timestamp, orderDirection: desc, where: { pair: $address }) {\n      id\n      timestamp\n      to\n      amount0\n      amount1\n      amountUSD\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n    }\n    swaps(first: 35, orderBy: timestamp, orderDirection: desc, where: { pair: $address }) {\n      id\n      timestamp\n      from\n      amount0In\n      amount1In\n      amount0Out\n      amount1Out\n      amountUSD\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n    }\n    burns(first: 35, orderBy: timestamp, orderDirection: desc, where: { pair: $address }) {\n      id\n      timestamp\n      sender\n      amount0\n      amount1\n      amountUSD\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n    }\n  }\n"
    ]);
    transactions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Transactions of the given pool, used on Pool page
 */ var POOL_TRANSACTIONS = (0,dist.gql)(transactions_templateObject());
var fetchPoolTransactions = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address) {
        var data, mints, burns, swaps, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(POOL_TRANSACTIONS, {
                            address: address
                        })
                    ];
                case 1:
                    data = _state.sent();
                    mints = data.mints.map(mapMints);
                    burns = data.burns.map(mapBurns);
                    swaps = data.swaps.map(mapSwaps);
                    return [
                        2,
                        {
                            data: (0,_to_consumable_array/* default */.Z)(mints).concat((0,_to_consumable_array/* default */.Z)(burns), (0,_to_consumable_array/* default */.Z)(swaps)),
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch transactions for pool ".concat(address), error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPoolTransactions(chainName, address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var transactions = (fetchPoolTransactions);

;// CONCATENATED MODULE: ./src/state/info/queries/protocol/chart.ts
/* eslint-disable no-await-in-loop */ 



function chart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query overviewCharts($startTime: Int!, $skip: Int!) {\n    pancakeDayDatas(first: 1000, skip: $skip, where: { date_gt: $startTime }, orderBy: date, orderDirection: asc) {\n      date\n      dailyVolumeUSD\n      totalLiquidityUSD\n    }\n  }\n"
    ]);
    chart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Data for displaying Liquidity and Volume charts on Overview page
 */ var PANCAKE_DAY_DATAS = (0,dist.gql)(chart_templateObject());
var getOverviewChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, skip) {
        var pancakeDayDatas, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(PANCAKE_DAY_DATAS, {
                            startTime: constant/* multiChainStartTime */.YM[chainName],
                            skip: skip
                        })
                    ];
                case 1:
                    pancakeDayDatas = _state.sent().pancakeDayDatas;
                    data = pancakeDayDatas.map(mapDayData);
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch overview chart data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getOverviewChartData(chainName, skip) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch historic chart data
 */ var useFetchGlobalChartData = function() {
    var _useState = _sliced_to_array(useState(), 2), overviewChartData = _useState[0], setOverviewChartData = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), error = _useState1[0], setError = _useState1[1];
    var chainName = useGetChainName();
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(function() {
                var data;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchChartData(chainName, getOverviewChartData)
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data) {
                                setOverviewChartData(data);
                            } else {
                                setError(true);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!overviewChartData && !error) {
            fetch();
        }
    }, [
        overviewChartData,
        error,
        chainName
    ]);
    return {
        error: error,
        data: overviewChartData
    };
};
var fetchGlobalChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName) {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        helpers_fetchChartData(chainName, getOverviewChartData)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchGlobalChartData(chainName) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var chart = ((/* unused pure expression or super */ null && (useFetchGlobalChartData)));

;// CONCATENATED MODULE: ./src/state/info/queries/protocol/overview.ts




function overview_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "query overview {\n      ",
        "(\n        ",
        "\n        first: 1) {\n        totalTransactions\n        totalVolumeUSD\n        totalLiquidityUSD\n      }\n    }"
    ]);
    overview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








/**
 * Latest Liquidity, Volume and Transaction count
 */ var getOverviewData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, block) {
        var factoryString, query, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    factoryString = (0,constant/* checkIsStableSwap */.J5)() ? "factories" : "pancakeFactories";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    query = (0,dist.gql)(overview_templateObject(), factoryString, block ? "block: { number: ".concat(block, "}") : "");
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query)
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Failed to fetch info overview", error);
                    return [
                        2,
                        {
                            data: null,
                            error: true
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getOverviewData(chainName, block) {
        return _ref.apply(this, arguments);
    };
}();
var formatPancakeFactoryResponse = function(rawPancakeFactory) {
    if (rawPancakeFactory) {
        return {
            totalTransactions: parseFloat(rawPancakeFactory.totalTransactions),
            totalVolumeUSD: parseFloat(rawPancakeFactory.totalVolumeUSD),
            totalLiquidityUSD: parseFloat(rawPancakeFactory.totalLiquidityUSD)
        };
    }
    return null;
};
var useFetchProtocolData = function() {
    var _useState = _sliced_to_array(useState({
        error: false
    }), 2), fetchState = _useState[0], setFetchState = _useState[1];
    var _getDeltaTimestamps = _sliced_to_array(getDeltaTimestamps(), 2), t24 = _getDeltaTimestamps[0], t48 = _getDeltaTimestamps[1];
    var _useBlocksFromTimestamps = useBlocksFromTimestamps([
        t24,
        t48
    ]), blocks = _useBlocksFromTimestamps.blocks, blockError = _useBlocksFromTimestamps.error;
    var _ref = _sliced_to_array(blocks !== null && blocks !== void 0 ? blocks : [], 2), block24 = _ref[0], block48 = _ref[1];
    var chainName = useGetChainName();
    useEffect(function() {
        var fetchData = function() {
            var _ref = _async_to_generator(function() {
                var _data_pancakeFactories, _data24_pancakeFactories, _data48_pancakeFactories, _block24_number, _block48_number, _ref, _ref_, error, data, _ref_1, error24, data24, _ref_2, error48, data48, anyError, overviewData, overviewData24, overviewData48, allDataAvailable, _getChangeForPeriod, volumeUSD, volumeUSDChange, liquidityUSDChange, _getChangeForPeriod1, txCount, txCountChange, protocolData;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all([
                                    getOverviewData(chainName),
                                    getOverviewData(chainName, (_block24_number = block24 === null || block24 === void 0 ? void 0 : block24.number) !== null && _block24_number !== void 0 ? _block24_number : undefined),
                                    getOverviewData(chainName, (_block48_number = block48 === null || block48 === void 0 ? void 0 : block48.number) !== null && _block48_number !== void 0 ? _block48_number : undefined)
                                ])
                            ];
                        case 1:
                            _ref = _sliced_to_array.apply(void 0, [
                                _state.sent(),
                                3
                            ]), _ref_ = _ref[0], error = _ref_.error, data = _ref_.data, _ref_1 = _ref[1], error24 = _ref_1.error, data24 = _ref_1.data, _ref_2 = _ref[2], error48 = _ref_2.error, data48 = _ref_2.data;
                            anyError = error || error24 || error48;
                            overviewData = formatPancakeFactoryResponse(data === null || data === void 0 ? void 0 : (_data_pancakeFactories = data.pancakeFactories) === null || _data_pancakeFactories === void 0 ? void 0 : _data_pancakeFactories[0]);
                            overviewData24 = formatPancakeFactoryResponse(data24 === null || data24 === void 0 ? void 0 : (_data24_pancakeFactories = data24.pancakeFactories) === null || _data24_pancakeFactories === void 0 ? void 0 : _data24_pancakeFactories[0]);
                            overviewData48 = formatPancakeFactoryResponse(data48 === null || data48 === void 0 ? void 0 : (_data48_pancakeFactories = data48.pancakeFactories) === null || _data48_pancakeFactories === void 0 ? void 0 : _data48_pancakeFactories[0]);
                            allDataAvailable = overviewData && overviewData24 && overviewData48;
                            if (anyError || !allDataAvailable) {
                                setFetchState({
                                    error: true
                                });
                            } else {
                                _getChangeForPeriod = _sliced_to_array(getChangeForPeriod(overviewData.totalVolumeUSD, overviewData24.totalVolumeUSD, overviewData48.totalVolumeUSD), 2), volumeUSD = _getChangeForPeriod[0], volumeUSDChange = _getChangeForPeriod[1];
                                liquidityUSDChange = getPercentChange(overviewData.totalLiquidityUSD, overviewData24.totalLiquidityUSD);
                                _getChangeForPeriod1 = _sliced_to_array(getChangeForPeriod(overviewData.totalTransactions, overviewData24.totalTransactions, overviewData48.totalTransactions), 2), txCount = _getChangeForPeriod1[0], txCountChange = _getChangeForPeriod1[1];
                                protocolData = {
                                    volumeUSD: volumeUSD,
                                    volumeUSDChange: typeof volumeUSDChange === "number" ? volumeUSDChange : 0,
                                    liquidityUSD: overviewData.totalLiquidityUSD,
                                    liquidityUSDChange: liquidityUSDChange,
                                    txCount: txCount,
                                    txCountChange: txCountChange
                                };
                                setFetchState({
                                    error: false,
                                    data: protocolData
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        var allBlocksAvailable = (block24 === null || block24 === void 0 ? void 0 : block24.number) && (block48 === null || block48 === void 0 ? void 0 : block48.number);
        if (allBlocksAvailable && !blockError && !fetchState.data) {
            fetchData();
        }
    }, [
        block24,
        block48,
        blockError,
        fetchState,
        chainName
    ]);
    return fetchState;
};
var fetchProtocolData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, block24, block48) {
        var _data_pancakeFactories, _data24_pancakeFactories, _data48_pancakeFactories, _block24_number, _block48_number, _ref, data, _ref_, data24, _ref_1, data48, overviewData, overviewData24, overviewData48, _getChangeForPeriod, volumeUSD, volumeUSDChange, liquidityUSDChange, _getChangeForPeriod1, txCount, txCountChange, protocolData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            getOverviewData(chainName),
                            getOverviewData(chainName, (_block24_number = block24 === null || block24 === void 0 ? void 0 : block24.number) !== null && _block24_number !== void 0 ? _block24_number : undefined),
                            getOverviewData(chainName, (_block48_number = block48 === null || block48 === void 0 ? void 0 : block48.number) !== null && _block48_number !== void 0 ? _block48_number : undefined)
                        ])
                    ];
                case 1:
                    _ref = src_sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), data = _ref[0].data, _ref_ = _ref[1], data24 = _ref_.data, _ref_1 = _ref[2], data48 = _ref_1.data;
                    if (data.factories && data.factories.length > 0) data.pancakeFactories = data.factories;
                    if (data24.factories && data24.factories.length > 0) data24.pancakeFactories = data24.factories;
                    if (data48.factories && data48.factories.length > 0) data48.pancakeFactories = data48.factories;
                    overviewData = formatPancakeFactoryResponse(data === null || data === void 0 ? void 0 : (_data_pancakeFactories = data.pancakeFactories) === null || _data_pancakeFactories === void 0 ? void 0 : _data_pancakeFactories[0]);
                    overviewData24 = formatPancakeFactoryResponse(data24 === null || data24 === void 0 ? void 0 : (_data24_pancakeFactories = data24.pancakeFactories) === null || _data24_pancakeFactories === void 0 ? void 0 : _data24_pancakeFactories[0]);
                    overviewData48 = formatPancakeFactoryResponse(data48 === null || data48 === void 0 ? void 0 : (_data48_pancakeFactories = data48.pancakeFactories) === null || _data48_pancakeFactories === void 0 ? void 0 : _data48_pancakeFactories[0]);
                    _getChangeForPeriod = (0,src_sliced_to_array/* default */.Z)((0,utils_getChangeForPeriod/* getChangeForPeriod */.T)(overviewData.totalVolumeUSD, overviewData24.totalVolumeUSD, overviewData48.totalVolumeUSD), 2), volumeUSD = _getChangeForPeriod[0], volumeUSDChange = _getChangeForPeriod[1];
                    liquidityUSDChange = (0,infoDataHelpers/* getPercentChange */.Y)(overviewData.totalLiquidityUSD, overviewData24.totalLiquidityUSD);
                    _getChangeForPeriod1 = (0,src_sliced_to_array/* default */.Z)((0,utils_getChangeForPeriod/* getChangeForPeriod */.T)(overviewData.totalTransactions, overviewData24.totalTransactions, overviewData48.totalTransactions), 2), txCount = _getChangeForPeriod1[0], txCountChange = _getChangeForPeriod1[1];
                    protocolData = {
                        volumeUSD: volumeUSD,
                        volumeUSDChange: typeof volumeUSDChange === "number" ? volumeUSDChange : 0,
                        liquidityUSD: overviewData.totalLiquidityUSD,
                        liquidityUSDChange: liquidityUSDChange,
                        txCount: txCount,
                        txCountChange: txCountChange
                    };
                    return [
                        2,
                        protocolData
                    ];
            }
        });
    });
    return function fetchProtocolData(chainName, block24, block48) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var overview = ((/* unused pure expression or super */ null && (useFetchProtocolData)));

;// CONCATENATED MODULE: ./src/state/info/queries/protocol/transactions.ts




function protocol_transactions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query overviewTransactions {\n    mints: mints(first: 33, orderBy: timestamp, orderDirection: desc) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      to\n      amount0\n      amount1\n      amountUSD\n    }\n    swaps: swaps(first: 33, orderBy: timestamp, orderDirection: desc) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      from\n      amount0In\n      amount1In\n      amount0Out\n      amount1Out\n      amountUSD\n    }\n    burns: burns(first: 33, orderBy: timestamp, orderDirection: desc) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      sender\n      amount0\n      amount1\n      amountUSD\n    }\n  }\n"
    ]);
    protocol_transactions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Transactions for Transaction table on the Home page
 */ var GLOBAL_TRANSACTIONS = (0,dist.gql)(protocol_transactions_templateObject());
var fetchTopTransactions = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName) {
        var data, mints, burns, swaps, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(GLOBAL_TRANSACTIONS)
                    ];
                case 1:
                    data = _state.sent();
                    if (!data) {
                        return [
                            2,
                            undefined
                        ];
                    }
                    mints = data.mints.map(mapMints);
                    burns = data.burns.map(mapBurns);
                    swaps = data.swaps.map(mapSwaps);
                    return [
                        2,
                        (0,_to_consumable_array/* default */.Z)(mints).concat((0,_to_consumable_array/* default */.Z)(burns), (0,_to_consumable_array/* default */.Z)(swaps)).sort(function(a, b) {
                            return parseInt(b.timestamp, 10) - parseInt(a.timestamp, 10);
                        })
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        undefined
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTopTransactions(chainName) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var protocol_transactions = (fetchTopTransactions);

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/chartData.ts



function chartData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query tokenDayDatas($startTime: Int!, $skip: Int!, $address: String!) {\n        tokenDayDatas(\n          first: 1000\n          skip: $skip\n          where: { token: $address, date_gt: $startTime }\n          orderBy: date\n          orderDirection: asc\n        ) {\n          date\n          dailyVolumeUSD\n          totalLiquidityUSD\n        }\n      }\n    "
    ]);
    chartData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var getTokenChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, skip, address) {
        var query, tokenDayDatas, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    query = (0,dist.gql)(chartData_templateObject());
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query, {
                            startTime: constant/* multiChainStartTime */.YM[chainName],
                            skip: skip,
                            address: address
                        })
                    ];
                case 1:
                    tokenDayDatas = _state.sent().tokenDayDatas;
                    data = tokenDayDatas.map(mapDayData);
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch token chart data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getTokenChartData(chainName, skip, address) {
        return _ref.apply(this, arguments);
    };
}();
var fetchTokenChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                fetchChartDataWithAddress(chainName, getTokenChartData, address)
            ];
        });
    });
    return function fetchTokenChartData(chainName, address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var tokens_chartData = (fetchTokenChartData);

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/poolsForToken.ts



function poolsForToken_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query poolsForToken($address: String!, $blacklist: [String!]) {\n    asToken0: pairs(\n      first: 15\n      orderBy: trackedReserve",
        "\n      orderDirection: desc\n      where: { totalTransactions_gt: ",
        ", token0: $address, token1_not_in: $blacklist }\n    ) {\n      id\n    }\n    asToken1: pairs(\n      first: 15\n      orderBy: trackedReserve",
        "\n      orderDirection: desc\n      where: { totalTransactions_gt: ",
        ", token1: $address, token0_not_in: $blacklist }\n    ) {\n      id\n    }\n  }\n"
    ]);
    poolsForToken_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Data for showing Pools table on the Token page
 */ var POOLS_FOR_TOKEN = function(chainName) {
    var transactionGT = chainName === "ETH" ? 1 : 100;
    return (0,dist.gql)(poolsForToken_templateObject(), constant/* multiChainQueryMainToken */.WR[chainName], transactionGT, constant/* multiChainQueryMainToken */.WR[chainName], transactionGT);
};
var fetchPoolsForToken = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address) {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(POOLS_FOR_TOKEN(chainName), {
                            address: address,
                            blacklist: info/* TOKEN_BLACKLIST */.tE
                        })
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        {
                            error: false,
                            addresses: data.asToken0.concat(data.asToken1).map(function(p) {
                                return p.id;
                            }).map(function(d) {
                                return d.toLowerCase();
                            })
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch pools for token ".concat(address), error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPoolsForToken(chainName, address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var poolsForToken = (fetchPoolsForToken);

// EXTERNAL MODULE: ../../node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(34498);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/views/Info/utils/infoQueryHelpers.ts
var infoQueryHelpers = __webpack_require__(70050);
;// CONCATENATED MODULE: ./src/state/info/queries/tokens/priceData.ts



function priceData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query tokenPriceData {\n      ",
        "\n    }\n  "
    ]);
    priceData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var getPriceSubqueries = function(chainName, tokenAddress, blocks) {
    return blocks.map(function(block) {
        return "\n      t".concat(block.timestamp, ':token(id:"').concat(tokenAddress, '", block: { number: ').concat(block.number, " }) {\n        derived").concat(constant/* multiChainQueryMainToken */.WR[chainName], "\n      }\n      b").concat(block.timestamp, ': bundle(id:"1", block: { number: ').concat(block.number, " }) {\n        ").concat(constant/* multiChainQueryMainToken */.WR[chainName].toLowerCase(), "Price\n      }\n    ");
    });
};
/**
 * Price data for token and bnb based on block number
 */ var priceQueryConstructor = function(subqueries) {
    return (0,dist.gql)(priceData_templateObject(), subqueries);
};
var fetchTokenPriceData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address, interval, startTimestamp) {
        var endTimestamp, timestamps, time, blocks, _blocks_length, blocksLength, data, prices, tokenPrices, mainToken, sortedTokenPrices, formattedHistory, i, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    endTimestamp = (0,getUnixTime/* default */.Z)(new Date());
                    timestamps = [];
                    time = startTimestamp;
                    while(time <= endTimestamp){
                        timestamps.push(time);
                        time += interval;
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        (0,utils_getBlocksFromTimestamps/* getBlocksFromTimestamps */.z)(timestamps, "asc", 500, chainName)
                    ];
                case 2:
                    blocks = _state.sent();
                    blocksLength = (_blocks_length = blocks === null || blocks === void 0 ? void 0 : blocks.length) !== null && _blocks_length !== void 0 ? _blocks_length : 0;
                    if (blocksLength > 0 && chainName === "BSC" && !(0,constant/* checkIsStableSwap */.J5)()) {
                        data = blocks[blocksLength - 1];
                        blocks[blocksLength - 1] = {
                            timestamp: data.timestamp,
                            number: data.number - 32
                        };
                    // nodeReal will sync the the 32 block before latest
                    }
                    if (!blocks || blocksLength === 0) {
                        console.error("Error fetching blocks for timestamps", timestamps);
                        return [
                            2,
                            {
                                error: false
                            }
                        ];
                    }
                    return [
                        4,
                        (0,infoQueryHelpers/* multiQuery */.L)(priceQueryConstructor, getPriceSubqueries(chainName, address, blocks), constant/* multiChainQueryEndPoint */.Ho[chainName], 200)
                    ];
                case 3:
                    prices = _state.sent();
                    console.warn("fetchTokenPriceData", {
                        chainName: chainName,
                        prices: prices
                    });
                    if (!prices) {
                        console.error("Price data failed to load");
                        return [
                            2,
                            {
                                error: false
                            }
                        ];
                    }
                    tokenPrices = [];
                    mainToken = constant/* multiChainQueryMainToken */.WR[chainName];
                    // Get Token prices in BNB
                    Object.keys(prices).forEach(function(priceKey) {
                        var timestamp = priceKey.split("t")[1];
                        // if its BNB price e.g. `b123` split('t')[1] will be undefined and skip BNB price entry
                        if (timestamp) {
                            var _prices_priceKey;
                            tokenPrices.push({
                                timestamp: timestamp,
                                derivedBNB: ((_prices_priceKey = prices[priceKey]) === null || _prices_priceKey === void 0 ? void 0 : _prices_priceKey["derived".concat(mainToken)]) ? parseFloat(prices[priceKey]["derived".concat(mainToken)]) : 0,
                                priceUSD: 0
                            });
                        }
                    });
                    console.warn("pricesPart1", tokenPrices);
                    // Go through BNB USD prices and calculate Token price based on it
                    Object.keys(prices).forEach(function(priceKey) {
                        var timestamp = priceKey.split("b")[1];
                        // if its Token price e.g. `t123` split('b')[1] will be undefined and skip Token price entry
                        if (timestamp) {
                            var tokenPriceIndex = tokenPrices.findIndex(function(tokenPrice) {
                                return tokenPrice.timestamp === timestamp;
                            });
                            if (tokenPriceIndex >= 0) {
                                var _prices_priceKey;
                                var derivedBNB = tokenPrices[tokenPriceIndex].derivedBNB;
                                var _prices_priceKey_;
                                tokenPrices[tokenPriceIndex].priceUSD = parseFloat((_prices_priceKey_ = (_prices_priceKey = prices[priceKey]) === null || _prices_priceKey === void 0 ? void 0 : _prices_priceKey["".concat(mainToken.toLowerCase(), "Price")]) !== null && _prices_priceKey_ !== void 0 ? _prices_priceKey_ : 0) * derivedBNB;
                            }
                        }
                    });
                    sortedTokenPrices = orderBy_default()(tokenPrices, function(tokenPrice) {
                        return parseInt(tokenPrice.timestamp, 10);
                    });
                    formattedHistory = [];
                    // for each timestamp, construct the open and close price
                    for(i = 0; i < sortedTokenPrices.length - 1; i++){
                        formattedHistory.push({
                            time: parseFloat(sortedTokenPrices[i].timestamp),
                            open: sortedTokenPrices[i].priceUSD,
                            close: sortedTokenPrices[i + 1].priceUSD,
                            high: sortedTokenPrices[i + 1].priceUSD,
                            low: sortedTokenPrices[i].priceUSD
                        });
                    }
                    return [
                        2,
                        {
                            data: formattedHistory,
                            error: false
                        }
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetch price data for token ".concat(address), error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTokenPriceData(chainName, address, interval, startTimestamp) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var priceData = (fetchTokenPriceData);

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/topTokens.ts




function topTokens_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query topTokens($blacklist: [ID!]) {\n        tokenDayDatas(\n          first: ",
        "\n          ",
        "\n          orderBy: dailyVolumeUSD\n          orderDirection: desc\n        ) {\n          id\n        }\n      }\n    "
    ]);
    topTokens_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Tokens to display on Home page
 * The actual data is later requested in tokenData.ts
 * Note: dailyTxns_gt: 300 is there to prevent fetching incorrectly priced tokens with high dailyVolumeUSD
 */ var fetchTopTokens = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, timestamp24hAgo) {
        var whereCondition, firstCount, query, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    whereCondition = chainName === "ETH" ? "where: { date_gt: ".concat(timestamp24hAgo, ", token_not_in: $blacklist, dailyVolumeUSD_gt:2000 }") : (0,constant/* checkIsStableSwap */.J5)() ? "" : "where: { dailyTxns_gt: 300, id_not_in: $blacklist, date_gt: ".concat(timestamp24hAgo, "}");
                    firstCount = 50;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    query = (0,dist.gql)(topTokens_templateObject(), firstCount, whereCondition);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query, {
                            blacklist: constant/* multiChainTokenBlackList */.z2[chainName]
                        })
                    ];
                case 2:
                    data = _state.sent();
                    // tokenDayDatas id has compound id "0xTOKENADDRESS-NUMBERS", extracting token address with .split('-')
                    return [
                        2,
                        data.tokenDayDatas.map(function(t) {
                            return t.id.split("-")[0];
                        })
                    ];
                case 3:
                    error = _state.sent();
                    console.warn("fetchTopTokens", {
                        chainName: chainName,
                        timestamp24hAgo: timestamp24hAgo
                    });
                    console.error("Failed to fetch top tokens", error);
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTopTokens(chainName, timestamp24hAgo) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch top addresses by volume
 */ var useTopTokenAddresses = function() {
    var _useState = _sliced_to_array(useState([]), 2), topTokenAddresses = _useState[0], setTopTokenAddresses = _useState[1];
    var _getDeltaTimestamps = _sliced_to_array(getDeltaTimestamps(), 1), timestamp24hAgo = _getDeltaTimestamps[0];
    var chainName = useGetChainName();
    var fetch = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var addresses;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchTopTokens(chainName, timestamp24hAgo)
                    ];
                case 1:
                    addresses = _state.sent();
                    if (addresses.length > 0) setTopTokenAddresses(addresses);
                    return [
                        2
                    ];
            }
        });
    }), [
        timestamp24hAgo,
        chainName
    ]);
    useEffect(function() {
        fetch();
    }, [
        chainName,
        fetch
    ]);
    return topTokenAddresses;
};
var fetchTokenAddresses = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName) {
        var _getDeltaTimestamps, timestamp24hAgo, addresses;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _getDeltaTimestamps = (0,src_sliced_to_array/* default */.Z)((0,utils_getDeltaTimestamps/* getDeltaTimestamps */.z)(), 1), timestamp24hAgo = _getDeltaTimestamps[0];
                    return [
                        4,
                        fetchTopTokens(chainName, timestamp24hAgo)
                    ];
                case 1:
                    addresses = _state.sent();
                    return [
                        2,
                        addresses
                    ];
            }
        });
    });
    return function fetchTokenAddresses(chainName) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var topTokens = ((/* unused pure expression or super */ null && (useTopTokenAddresses)));

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/tokenData.ts
/* eslint-disable no-param-reassign */ 





function tokenData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query tokens {\n        now: ",
        "\n        oneDayAgo: ",
        "\n        twoDaysAgo: ",
        "\n        oneWeekAgo: ",
        "\n        twoWeeksAgo: ",
        "\n      }\n    "
    ]);
    tokenData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








/**
 * Main token data to display on Token page
 */ var TOKEN_AT_BLOCK = function(chainName, block, tokens) {
    var addressesString = '["'.concat(tokens.join('","'), '"]');
    var blockString = block ? "block: {number: ".concat(block, "}") : "";
    return "tokens(\n      where: {id_in: ".concat(addressesString, "}\n      ").concat(blockString, "\n      orderBy: tradeVolumeUSD\n      orderDirection: desc\n    ) {\n      id\n      symbol\n      name\n      derived").concat(constant/* multiChainQueryMainToken */.WR[chainName], "\n      derivedUSD\n      tradeVolumeUSD\n      totalTransactions\n      totalLiquidity\n    }\n  ");
};
var fetchTokenData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, block24h, block48h, block7d, block14d, tokenAddresses) {
        var query, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    query = (0,dist.gql)(tokenData_templateObject(), TOKEN_AT_BLOCK(chainName, null, tokenAddresses), TOKEN_AT_BLOCK(chainName, block24h, tokenAddresses), TOKEN_AT_BLOCK(chainName, block48h, tokenAddresses), TOKEN_AT_BLOCK(chainName, block7d, tokenAddresses), TOKEN_AT_BLOCK(chainName, block14d, tokenAddresses));
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query)
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch token data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTokenData(chainName, block24h, block48h, block7d, block14d, tokenAddresses) {
        return _ref.apply(this, arguments);
    };
}();
// Transforms tokens into "0xADDRESS: { ...TokenFields }" format and cast strings to numbers
var parseTokenData = function(tokens) {
    if (!tokens) {
        return {};
    }
    return tokens.reduce(function(accum, tokenData) {
        var derivedBNB = tokenData.derivedBNB, derivedUSD = tokenData.derivedUSD, tradeVolumeUSD = tokenData.tradeVolumeUSD, totalTransactions = tokenData.totalTransactions, totalLiquidity = tokenData.totalLiquidity, derivedETH = tokenData.derivedETH;
        accum[tokenData.id.toLowerCase()] = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, tokenData), {
            derivedBNB: derivedBNB ? 0 : parseFloat(derivedBNB),
            derivedETH: derivedETH ? 0 : parseFloat(derivedETH),
            derivedUSD: parseFloat(derivedUSD),
            tradeVolumeUSD: parseFloat(tradeVolumeUSD),
            totalTransactions: parseFloat(totalTransactions),
            totalLiquidity: parseFloat(totalLiquidity)
        });
        return accum;
    }, {});
};
/**
 * Fetch top addresses by volume
 */ var useFetchedTokenDatas = function(chainName, tokenAddresses) {
    var _useState = _sliced_to_array(useState({
        error: false
    }), 2), fetchState = _useState[0], setFetchState = _useState[1];
    var _getDeltaTimestamps = _sliced_to_array(getDeltaTimestamps(), 4), t24h = _getDeltaTimestamps[0], t48h = _getDeltaTimestamps[1], t7d = _getDeltaTimestamps[2], t14d = _getDeltaTimestamps[3];
    var _useBlocksFromTimestamps = useBlocksFromTimestamps([
        t24h,
        t48h,
        t7d,
        t14d
    ]), blocks = _useBlocksFromTimestamps.blocks, blockError = _useBlocksFromTimestamps.error;
    var _ref = _sliced_to_array(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = _ref[0], block48h = _ref[1], block7d = _ref[2], block14d = _ref[3];
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(function() {
                var _ref, error, data, parsed, parsed24, parsed48, parsed7d, parsed14d, formatted;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchTokenData(chainName, block24h.number, block48h.number, block7d.number, block14d.number, tokenAddresses)
                            ];
                        case 1:
                            _ref = _state.sent(), error = _ref.error, data = _ref.data;
                            if (error) {
                                setFetchState({
                                    error: true
                                });
                            } else {
                                parsed = parseTokenData(data === null || data === void 0 ? void 0 : data.now);
                                parsed24 = parseTokenData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                                parsed48 = parseTokenData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                                parsed7d = parseTokenData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                                parsed14d = parseTokenData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                                formatted = tokenAddresses.reduce(function(accum, address) {
                                    var current = parsed[address];
                                    var oneDay = parsed24[address];
                                    var twoDays = parsed48[address];
                                    var week = parsed7d[address];
                                    var twoWeeks = parsed14d[address];
                                    var _getChangeForPeriod = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.tradeVolumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.tradeVolumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.tradeVolumeUSD), 2), volumeUSD = _getChangeForPeriod[0], volumeUSDChange = _getChangeForPeriod[1];
                                    var _getChangeForPeriod1 = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.tradeVolumeUSD, week === null || week === void 0 ? void 0 : week.tradeVolumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.tradeVolumeUSD), 1), volumeUSDWeek = _getChangeForPeriod1[0];
                                    var liquidityUSD = current ? current.totalLiquidity * current.derivedUSD : 0;
                                    var liquidityUSDOneDayAgo = oneDay ? oneDay.totalLiquidity * oneDay.derivedUSD : 0;
                                    var liquidityUSDChange = getPercentChange(liquidityUSD, liquidityUSDOneDayAgo);
                                    var liquidityToken = current ? current.totalLiquidity : 0;
                                    // Prices of tokens for now, 24h ago and 7d ago
                                    var priceUSD = current ? current.derivedUSD : 0;
                                    var priceUSDOneDay = oneDay ? oneDay.derivedUSD : 0;
                                    var priceUSDWeek = week ? week.derivedUSD : 0;
                                    var priceUSDChange = getPercentChange(priceUSD, priceUSDOneDay);
                                    var priceUSDChangeWeek = getPercentChange(priceUSD, priceUSDWeek);
                                    var txCount = getAmountChange(current === null || current === void 0 ? void 0 : current.totalTransactions, oneDay === null || oneDay === void 0 ? void 0 : oneDay.totalTransactions);
                                    accum[address] = {
                                        exists: !!current,
                                        address: address,
                                        name: current ? current.name : "",
                                        symbol: current ? current.symbol : "",
                                        volumeUSD: volumeUSD,
                                        volumeUSDChange: volumeUSDChange,
                                        volumeUSDWeek: volumeUSDWeek,
                                        txCount: txCount,
                                        liquidityUSD: liquidityUSD,
                                        liquidityUSDChange: liquidityUSDChange,
                                        liquidityToken: liquidityToken,
                                        priceUSD: priceUSD,
                                        priceUSDChange: priceUSDChange,
                                        priceUSDChangeWeek: priceUSDChangeWeek
                                    };
                                    return accum;
                                }, {});
                                setFetchState({
                                    data: formatted,
                                    error: false
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        var allBlocksAvailable = (block24h === null || block24h === void 0 ? void 0 : block24h.number) && (block48h === null || block48h === void 0 ? void 0 : block48h.number) && (block7d === null || block7d === void 0 ? void 0 : block7d.number) && (block14d === null || block14d === void 0 ? void 0 : block14d.number);
        if (tokenAddresses.length > 0 && allBlocksAvailable && !blockError) {
            fetch();
        }
    }, [
        tokenAddresses,
        block24h,
        block48h,
        block7d,
        block14d,
        blockError,
        chainName
    ]);
    return fetchState;
};
var fetchAllTokenDataByAddresses = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, blocks, tokenAddresses) {
        var _ref, block24h, block48h, block7d, block14d, data, parsed, parsed24, parsed48, parsed7d, parsed14d, formatted;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ref = (0,src_sliced_to_array/* default */.Z)(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = _ref[0], block48h = _ref[1], block7d = _ref[2], block14d = _ref[3];
                    return [
                        4,
                        fetchTokenData(chainName, block24h.number, block48h.number, block7d.number, block14d.number, tokenAddresses)
                    ];
                case 1:
                    data = _state.sent().data;
                    parsed = parseTokenData(data === null || data === void 0 ? void 0 : data.now);
                    parsed24 = parseTokenData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                    parsed48 = parseTokenData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                    parsed7d = parseTokenData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                    parsed14d = parseTokenData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                    formatted = tokenAddresses.reduce(function(accum, address) {
                        var current = parsed[address];
                        var oneDay = parsed24[address];
                        var twoDays = parsed48[address];
                        var week = parsed7d[address];
                        var twoWeeks = parsed14d[address];
                        var _getChangeForPeriod = (0,src_sliced_to_array/* default */.Z)((0,utils_getChangeForPeriod/* getChangeForPeriod */.T)(current === null || current === void 0 ? void 0 : current.tradeVolumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.tradeVolumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.tradeVolumeUSD), 2), volumeUSD = _getChangeForPeriod[0], volumeUSDChange = _getChangeForPeriod[1];
                        var _getChangeForPeriod1 = (0,src_sliced_to_array/* default */.Z)((0,utils_getChangeForPeriod/* getChangeForPeriod */.T)(current === null || current === void 0 ? void 0 : current.tradeVolumeUSD, week === null || week === void 0 ? void 0 : week.tradeVolumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.tradeVolumeUSD), 1), volumeUSDWeek = _getChangeForPeriod1[0];
                        var liquidityUSD = current ? current.totalLiquidity * current.derivedUSD : 0;
                        var liquidityUSDOneDayAgo = oneDay ? oneDay.totalLiquidity * oneDay.derivedUSD : 0;
                        var liquidityUSDChange = (0,infoDataHelpers/* getPercentChange */.Y)(liquidityUSD, liquidityUSDOneDayAgo);
                        var liquidityToken = current ? current.totalLiquidity : 0;
                        // Prices of tokens for now, 24h ago and 7d ago
                        var priceUSD = current ? current.derivedUSD : 0;
                        var priceUSDOneDay = oneDay ? oneDay.derivedUSD : 0;
                        var priceUSDWeek = week ? week.derivedUSD : 0;
                        var priceUSDChange = (0,infoDataHelpers/* getPercentChange */.Y)(priceUSD, priceUSDOneDay);
                        var priceUSDChangeWeek = (0,infoDataHelpers/* getPercentChange */.Y)(priceUSD, priceUSDWeek);
                        var txCount = (0,infoDataHelpers/* getAmountChange */.D)(current === null || current === void 0 ? void 0 : current.totalTransactions, oneDay === null || oneDay === void 0 ? void 0 : oneDay.totalTransactions);
                        accum[address] = {
                            data: {
                                exists: !!current,
                                address: address,
                                name: current ? current.name : "",
                                symbol: current ? current.symbol : "",
                                volumeUSD: volumeUSD,
                                volumeUSDChange: volumeUSDChange,
                                volumeUSDWeek: volumeUSDWeek,
                                txCount: txCount,
                                liquidityUSD: liquidityUSD,
                                liquidityUSDChange: liquidityUSDChange,
                                liquidityToken: liquidityToken,
                                priceUSD: priceUSD,
                                priceUSDChange: priceUSDChange,
                                priceUSDChangeWeek: priceUSDChangeWeek
                            }
                        };
                        return accum;
                    }, {});
                    return [
                        2,
                        formatted
                    ];
            }
        });
    });
    return function fetchAllTokenDataByAddresses(chainName, blocks, tokenAddresses) {
        return _ref.apply(this, arguments);
    };
}();
var fetchAllTokenData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, blocks) {
        var tokenAddresses, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchTokenAddresses(chainName)
                    ];
                case 1:
                    tokenAddresses = _state.sent();
                    return [
                        4,
                        fetchAllTokenDataByAddresses(chainName, blocks, tokenAddresses)
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchAllTokenData(chainName, blocks) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var tokenData = ((/* unused pure expression or super */ null && (useFetchedTokenDatas)));

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/transactions.ts




function tokens_transactions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query tokenTransactions($address: String!) {\n      mintsAs0: mints(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        to\n        amount0\n        amount1\n        amountUSD\n      }\n      mintsAs1: mints(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        to\n        amount0\n        amount1\n        amountUSD\n      }\n      swapsAs0: swaps(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        from\n        amount0In\n        amount1In\n        amount0Out\n        amount1Out\n        amountUSD\n      }\n      swapsAs1: swaps(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        from\n        amount0In\n        amount1In\n        amount0Out\n        amount1Out\n        amountUSD\n      }\n      burnsAs0: burns(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        sender\n        amount0\n        amount1\n        amountUSD\n      }\n      burnsAs1: burns(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        sender\n        amount0\n        amount1\n        amountUSD\n      }\n    }\n  "
    ]);
    tokens_transactions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Data to display transaction table on Token page
 */ var TOKEN_TRANSACTIONS = function() {
    var isStableSwap = (0,constant/* checkIsStableSwap */.J5)();
    var whereToken0 = isStableSwap ? "pair_: {token0: $address}" : "token0: $address";
    var whereToken1 = isStableSwap ? "pair_: {token1: $address}" : "token1: $address";
    return (0,dist.gql)(tokens_transactions_templateObject(), whereToken0, whereToken1, whereToken0, whereToken1, whereToken0, whereToken1);
};
var fetchTokenTransactions = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address) {
        var data, mints0, mints1, burns0, burns1, swaps0, swaps1, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(TOKEN_TRANSACTIONS(), {
                            address: address
                        })
                    ];
                case 1:
                    data = _state.sent();
                    mints0 = data.mintsAs0.map(mapMints);
                    mints1 = data.mintsAs1.map(mapMints);
                    burns0 = data.burnsAs0.map(mapBurns);
                    burns1 = data.burnsAs1.map(mapBurns);
                    swaps0 = data.swapsAs0.map(mapSwaps);
                    swaps1 = data.swapsAs1.map(mapSwaps);
                    return [
                        2,
                        {
                            data: (0,_to_consumable_array/* default */.Z)(mints0).concat((0,_to_consumable_array/* default */.Z)(mints1), (0,_to_consumable_array/* default */.Z)(burns0), (0,_to_consumable_array/* default */.Z)(burns1), (0,_to_consumable_array/* default */.Z)(swaps0), (0,_to_consumable_array/* default */.Z)(swaps1)),
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch transactions for token ".concat(address), error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTokenTransactions(chainName, address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var tokens_transactions = (fetchTokenTransactions);

;// CONCATENATED MODULE: ./src/state/info/hooks.ts






















// Protocol hooks
var refreshIntervalForInfo = 15000 // 15s
;
var SWR_SETTINGS_WITHOUT_REFETCH = {
    errorRetryCount: 3,
    errorRetryInterval: 3000
};
var SWR_SETTINGS = (0,src_object_spread/* default */.Z)({
    refreshInterval: refreshIntervalForInfo
}, SWR_SETTINGS_WITHOUT_REFETCH);
var useProtocolDataSWR = function() {
    var chainName = hooks_useGetChainName();
    var _getDeltaTimestamps = (0,src_sliced_to_array/* default */.Z)((0,utils_getDeltaTimestamps/* getDeltaTimestamps */.z)(), 2), t24 = _getDeltaTimestamps[0], t48 = _getDeltaTimestamps[1];
    var blocks = useBlockFromTimeStampSWR([
        t24,
        t48
    ]).blocks;
    var _ref = (0,src_sliced_to_array/* default */.Z)(blocks !== null && blocks !== void 0 ? blocks : [], 2), block24 = _ref[0], block48 = _ref[1];
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var _useSWRImmutable = (0,immutable_dist/* default */.Z)(chainName && block24 && block48 ? [
        "info/protocol/updateProtocolData/".concat(type),
        chainName
    ] : null, function() {
        return fetchProtocolData(chainName, block24, block48);
    }, SWR_SETTINGS_WITHOUT_REFETCH), protocolData = _useSWRImmutable.data;
    return protocolData !== null && protocolData !== void 0 ? protocolData : undefined;
};
var useProtocolChartDataSWR = function() {
    var chainName = hooks_useGetChainName();
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var _useSWRImmutable = (0,immutable_dist/* default */.Z)([
        "info/protocol/updateProtocolChartData/".concat(type),
        chainName
    ], function() {
        return fetchGlobalChartData(chainName);
    }, SWR_SETTINGS_WITHOUT_REFETCH), chartData = _useSWRImmutable.data;
    return chartData !== null && chartData !== void 0 ? chartData : undefined;
};
var useProtocolTransactionsSWR = function() {
    var chainName = hooks_useGetChainName();
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var _useSWRImmutable = (0,immutable_dist/* default */.Z)([
        "info/protocol/updateProtocolTransactionsData/".concat(type),
        chainName
    ], function() {
        return protocol_transactions(chainName);
    }, SWR_SETTINGS), transactions = _useSWRImmutable.data;
    return transactions !== null && transactions !== void 0 ? transactions : undefined;
};
var useAllPoolDataSWR = function() {
    var chainName = hooks_useGetChainName();
    var _getDeltaTimestamps = (0,src_sliced_to_array/* default */.Z)((0,utils_getDeltaTimestamps/* getDeltaTimestamps */.z)(), 4), t24h = _getDeltaTimestamps[0], t48h = _getDeltaTimestamps[1], t7d = _getDeltaTimestamps[2], t14d = _getDeltaTimestamps[3];
    var blocks = useBlockFromTimeStampSWR([
        t24h,
        t48h,
        t7d,
        t14d
    ]).blocks;
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var data = (0,immutable_dist/* default */.Z)(blocks && chainName && [
        "info/pools/data/".concat(type),
        chainName
    ], function() {
        return fetchAllPoolData(blocks, chainName);
    }, SWR_SETTINGS_WITHOUT_REFETCH).data;
    return data !== null && data !== void 0 ? data : {};
};
var usePoolDatasSWR = function(poolAddresses) {
    var name = poolAddresses.join("");
    var chainName = hooks_useGetChainName();
    var _getDeltaTimestamps = (0,src_sliced_to_array/* default */.Z)((0,utils_getDeltaTimestamps/* getDeltaTimestamps */.z)(), 4), t24h = _getDeltaTimestamps[0], t48h = _getDeltaTimestamps[1], t7d = _getDeltaTimestamps[2], t14d = _getDeltaTimestamps[3];
    var blocks = useBlockFromTimeStampSWR([
        t24h,
        t48h,
        t7d,
        t14d
    ]).blocks;
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var data = (0,immutable_dist/* default */.Z)(blocks && chainName && [
        "info/pool/data/".concat(name, "/").concat(type),
        chainName
    ], function() {
        return fetchAllPoolDataWithAddress(blocks, chainName, poolAddresses);
    }, SWR_SETTINGS).data;
    var poolsWithData = poolAddresses.map(function(address) {
        var _data_address;
        return data === null || data === void 0 ? void 0 : (_data_address = data[address]) === null || _data_address === void 0 ? void 0 : _data_address.data;
    }).filter(function(pool) {
        return pool;
    });
    return poolsWithData;
};
var usePoolChartDataSWR = function(address) {
    var chainName = hooks_useGetChainName();
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var data = (0,immutable_dist/* default */.Z)([
        "info/pool/chartData/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return chartData(chainName, address);
    }, SWR_SETTINGS_WITHOUT_REFETCH).data;
    var _data_data;
    return (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : undefined;
};
var usePoolTransactionsSWR = function(address) {
    var chainName = hooks_useGetChainName();
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var data = (0,immutable_dist/* default */.Z)([
        "info/pool/transactionsData/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return transactions(chainName, address);
    }, SWR_SETTINGS).data;
    var _data_data;
    return (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : undefined;
};
// Tokens hooks
var useAllTokenDataSWR = function() {
    var chainName = hooks_useGetChainName();
    var _getDeltaTimestamps = (0,src_sliced_to_array/* default */.Z)((0,utils_getDeltaTimestamps/* getDeltaTimestamps */.z)(), 4), t24h = _getDeltaTimestamps[0], t48h = _getDeltaTimestamps[1], t7d = _getDeltaTimestamps[2], t14d = _getDeltaTimestamps[3];
    var blocks = useBlockFromTimeStampSWR([
        t24h,
        t48h,
        t7d,
        t14d
    ]).blocks;
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var data = (0,immutable_dist/* default */.Z)(blocks && chainName && [
        "info/token/data/".concat(type),
        chainName
    ], function() {
        return fetchAllTokenData(chainName, blocks);
    }, SWR_SETTINGS_WITHOUT_REFETCH).data;
    return data !== null && data !== void 0 ? data : {};
};
var graphPerPage = 50;
var fetcher = function(addresses, chainName, blocks) {
    var times = Math.ceil(addresses.length / graphPerPage);
    var addressGroup = [];
    for(var i = 0; i < times; i++){
        addressGroup.push(addresses.slice(i * graphPerPage, (i + 1) * graphPerPage));
    }
    return Promise.all(addressGroup.map(function(d) {
        return fetchAllTokenDataByAddresses(chainName, blocks, d);
    }));
};
var useTokenDatasSWR = function(addresses) {
    var withSettings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var name = addresses.join("");
    var chainName = hooks_useGetChainName();
    var _getDeltaTimestamps = (0,src_sliced_to_array/* default */.Z)((0,utils_getDeltaTimestamps/* getDeltaTimestamps */.z)(), 4), t24h = _getDeltaTimestamps[0], t48h = _getDeltaTimestamps[1], t7d = _getDeltaTimestamps[2], t14d = _getDeltaTimestamps[3];
    var blocks = useBlockFromTimeStampSWR([
        t24h,
        t48h,
        t7d,
        t14d
    ]).blocks;
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var data = (0,immutable_dist/* default */.Z)(blocks && chainName && [
        "info/token/data/".concat(name, "/").concat(type),
        chainName
    ], function() {
        return fetcher(addresses, chainName, blocks);
    }, withSettings ? SWR_SETTINGS : SWR_SETTINGS_WITHOUT_REFETCH).data;
    var allData = (0,react.useMemo)(function() {
        return data && data.length > 0 ? data.reduce(function(a, b) {
            return (0,src_object_spread/* default */.Z)({}, a, b);
        }, {}) : {};
    }, [
        data
    ]);
    var tokensWithData = (0,react.useMemo)(function() {
        if (!addresses && allData) {
            return undefined;
        }
        return addresses.map(function(a) {
            var _allData_a;
            return allData === null || allData === void 0 ? void 0 : (_allData_a = allData[a]) === null || _allData_a === void 0 ? void 0 : _allData_a.data;
        }).filter(function(d) {
            return d && d.exists;
        });
    }, [
        addresses,
        allData
    ]);
    return tokensWithData !== null && tokensWithData !== void 0 ? tokensWithData : undefined;
};
var useTokenDataSWR = function(address) {
    var allTokenData = useTokenDatasSWR([
        address
    ]);
    var _allTokenData_find;
    return (_allTokenData_find = allTokenData.find(function(d) {
        return d.address === address;
    })) !== null && _allTokenData_find !== void 0 ? _allTokenData_find : undefined;
};
var usePoolsForTokenSWR = function(address) {
    var chainName = hooks_useGetChainName();
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var data = (0,immutable_dist/* default */.Z)([
        "info/token/poolAddress/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return poolsForToken(chainName, address);
    }, SWR_SETTINGS_WITHOUT_REFETCH).data;
    var _data_addresses;
    return (_data_addresses = data === null || data === void 0 ? void 0 : data.addresses) !== null && _data_addresses !== void 0 ? _data_addresses : undefined;
};
var useTokenChartDataSWR = function(address) {
    var chainName = hooks_useGetChainName();
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var data = (0,immutable_dist/* default */.Z)(address && chainName && [
        "info/token/chartData/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return tokens_chartData(chainName, address);
    }, SWR_SETTINGS).data;
    var _data_data;
    return (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : undefined;
};
var useTokenPriceDataSWR = function(address, interval, timeWindow) {
    var utcCurrentTime = (0,getUnixTime/* default */.Z)(new Date()) * 1000;
    var startTimestamp = (0,getUnixTime/* default */.Z)((0,startOfHour/* default */.Z)((0,sub/* default */.Z)(utcCurrentTime, timeWindow)));
    var chainName = hooks_useGetChainName();
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var data = (0,immutable_dist/* default */.Z)([
        "info/token/priceData/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return priceData(chainName, address, interval, startTimestamp);
    }, SWR_SETTINGS).data;
    var _data_data;
    return (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : undefined;
};
var useTokenTransactionsSWR = function(address) {
    var chainName = hooks_useGetChainName();
    var type = (0,constant/* checkIsStableSwap */.J5)() ? "stableSwap" : "swap";
    var data = (0,immutable_dist/* default */.Z)([
        "info/token/transactionsData/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return tokens_transactions(chainName, address);
    }, SWR_SETTINGS).data;
    var _data_data;
    return (_data_data = data === null || data === void 0 ? void 0 : data.data) !== null && _data_data !== void 0 ? _data_data : undefined;
};
var hooks_useGetChainName = function() {
    var path = window.location.href;
    var getChain = (0,react.useCallback)(function() {
        if (path.includes("eth")) return "ETH";
        return "BSC";
    }, [
        path
    ]);
    var _useState = (0,src_sliced_to_array/* default */.Z)((0,react.useState)(getChain()), 2), name = _useState[0], setName = _useState[1];
    var result = (0,react.useMemo)(function() {
        return name;
    }, [
        name
    ]);
    (0,react.useEffect)(function() {
        setName(getChain());
    }, [
        getChain
    ]);
    return result;
};
var useStableSwapAPR = function(address) {
    var chainName = hooks_useGetChainName();
    var data = (0,immutable_dist/* default */.Z)(address && [
        "info/pool/stableAPR/".concat(address, "/"),
        chainName
    ], function() {
        return getAprsForStableFarm(address);
    }, SWR_SETTINGS).data;
    return data === null || data === void 0 ? void 0 : data.toNumber();
};
var stableSwapAPRWithAddressesFetcher = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(addresses) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                Promise.all(addresses.map(function(d) {
                    return getAprsForStableFarm(d);
                }))
            ];
        });
    });
    return function stableSwapAPRWithAddressesFetcher(addresses) {
        return _ref.apply(this, arguments);
    };
}();
var useStableSwapTopPoolsAPR = function(addresses) {
    var isStableSwap = (0,constant/* checkIsStableSwap */.J5)();
    var chainName = hooks_useGetChainName();
    var data = (0,immutable_dist/* default */.Z)(isStableSwap && (addresses === null || addresses === void 0 ? void 0 : addresses.length) > 0 && [
        "info/pool/stableAPRs/Addresses/",
        chainName
    ], function() {
        return stableSwapAPRWithAddressesFetcher(addresses);
    }, SWR_SETTINGS_WITHOUT_REFETCH).data;
    var addressWithAPR = {};
    data === null || data === void 0 ? void 0 : data.forEach(function(d, index) {
        addressWithAPR[addresses[index]] = d === null || d === void 0 ? void 0 : d.toNumber();
    });
    return isStableSwap ? addressWithAPR : {};
};
var useMultiChainPath = function() {
    var router = (0,next_router.useRouter)();
    var chainName = router.query.chainName;
    return chainName ? "/".concat(chainName) : "";
};
var useStableSwapPath = function() {
    return (0,constant/* checkIsStableSwap */.J5)() ? "?type=stableSwap" : "";
};


/***/ }),

/***/ 43386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ TransactionType; }
/* harmony export */ });
var TransactionType;
(function(TransactionType) {
    TransactionType[TransactionType["SWAP"] = 0] = "SWAP";
    TransactionType[TransactionType["MINT"] = 1] = "MINT";
    TransactionType[TransactionType["BURN"] = 2] = "BURN";
})(TransactionType || (TransactionType = {}));


/***/ }),

/***/ 8244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getChangeForPeriod; }
/* harmony export */ });
/* harmony import */ var _views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27867);

/**
 * Given current value and value 1 and 2 periods (e.g. 1day + 2days, 1week - 2weeks) returns the amount change for latest period
 * and percentage change compared to the previous period.
 * @param valueNow - current value
 * @param valueOnePeriodAgo - value 1 period ago (e.g. 1 day or 1 week ago), period unit must be same as valueTwoPeriodsAgo
 * @param valueTwoPeriodsAgo - value 2 periods ago (e.g. 2 days or 2 weeks ago), period unit must be same as valueOnePeriodAgo
 * @returns amount change for the latest period and percentage change compared to previous period
 */ var getChangeForPeriod = function(valueNow, valueOnePeriodAgo, valueTwoPeriodsAgo) {
    var currentPeriodAmount = (0,_views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getAmountChange */ .D)(valueNow, valueOnePeriodAgo);
    var previousPeriodAmount = (0,_views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getAmountChange */ .D)(valueOnePeriodAgo, valueTwoPeriodsAgo);
    var percentageChange = (0,_views_Info_utils_infoDataHelpers__WEBPACK_IMPORTED_MODULE_0__/* .getPercentChange */ .Y)(currentPeriodAmount, previousPeriodAmount);
    return [
        currentPeriodAmount,
        percentageChange
    ];
};


/***/ }),

/***/ 14966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ getDeltaTimestamps; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28401);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18717);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7069);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85899);

/**
 * Returns UTC timestamps for 24h ago, 48h ago, 7d ago and 14d ago relative to current date and time
 */ var getDeltaTimestamps = function() {
    var utcCurrentTime = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date()) * 1000;
    var t24h = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(utcCurrentTime, 1)));
    var t48h = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(utcCurrentTime, 2)));
    var t7d = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(utcCurrentTime, 1)));
    var t14d = (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(utcCurrentTime, 2)));
    return [
        t24h,
        t48h,
        t7d,
        t14d
    ];
};


/***/ }),

/***/ 14279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eh": function() { return /* binding */ Arrow; },
/* harmony export */   "Ob": function() { return /* binding */ PageButtons; },
/* harmony export */   "SS": function() { return /* binding */ Break; },
/* harmony export */   "_J": function() { return /* binding */ ClickableColumnHeader; },
/* harmony export */   "y6": function() { return /* binding */ TableWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3411);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32301);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33080);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding-top: 16px;\n  flex-direction: column;\n  gap: 16px;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  ",
        " {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0.2em;\n  margin-bottom: 1.2em;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  padding: 0 20px;\n  :hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  background-color: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var ClickableColumnHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-69956645-0"
})(_templateObject());
var TableWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-69956645-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii[0];
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
var PageButtons = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69956645-2"
})(_templateObject2());
var Arrow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69956645-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var Break = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-69956645-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});


/***/ }),

/***/ 27867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getAmountChange; },
/* harmony export */   "Y": function() { return /* binding */ getPercentChange; }
/* harmony export */ });
/**
 * Get increase/decrease of value compared to the previous value (e.g. 24h volume compared to 24h volume the day before )
 * @param valueNow - more recent value
 * @param valueBefore - value to compare with
 */ var getAmountChange = function(valueNow, valueBefore) {
    if (valueNow && valueBefore) {
        return valueNow - valueBefore;
    }
    if (valueNow) {
        return valueNow;
    }
    return 0;
};
/**
 * Get increase/decrease of value compared to the previous value as a percentage
 * @param valueNow - more recent value
 * @param valueBefore - value to compare with
 */ var getPercentChange = function(valueNow, valueBefore) {
    if (valueNow && valueBefore) {
        return (valueNow - valueBefore) / valueBefore * 100;
    }
    return 0;
};


/***/ })

}]);